/**
 * ¿Este usuario sólo compra y vende?
 *
 * Unique Perfumes no fabrica. Las pantallas de producción —el Gantt, la
 * secuencia, el plan y la producción diaria— no le dirían nada: su empresa no
 * tiene órdenes de fabricación, así que vería pantallas vacías con pinta de
 * avería.
 *
 * Comparte la query `['auth-me']` con `useAllowedEmpresas` y `useIsEmpresaAll`,
 * así que no cuesta una llamada más. Y la respuesta llega resuelta del servidor:
 * aquí no se decide quién produce, sólo se lee.
 */
import { useQuery } from '@tanstack/react-query'
import { authApi } from '@/services/api'

export function useSinProduccion(): boolean {
  const { data } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,  // 1 h — los roles no cambian a mitad de sesión
    gcTime:    60 * 60 * 1000,
    retry: false,
  })
  // Mientras no se sabe, se asume que SÍ produce: enseñar de más durante medio
  // segundo es mejor que parpadear escondiendo media aplicación.
  return data?.sinProduccion ?? false
}
